import { defineMessages } from 'react-intl'

import { AbortError } from '@app/errors/AbortError'
import { AppError } from '@app/errors/AppError'

import { profileUserSelector } from '@app/store/slices/profile'
import { createThunk } from '@app/store/thunk'
import type { StoreParentProfile, StoreProfileUser, StoreSitterProfile } from '@app/store/types/profile'

import { assertMountPush } from '@app/components/Mount/actions'

import { getIntl } from './initial'

export function requireUser() {
  return createThunk(async (dispatch, getState) => {
    const user = profileUserSelector(getState())
    if (user && user.account_type !== 'visitor') {
      return user
    }
    const { promise, resolve, reject } = Promise.withResolvers<StoreParentProfile | StoreSitterProfile>()
    let handled = false
    await dispatch(
      assertMountPush(
        import('@app/components/Login/LoginModal').then(m => m.LoginModal),
        {
          props: {
            onLogin: result => () => {
              if (handled) return
              try {
                resolve(result.user)
                handled = true
              } catch (error) {
                reject(error)
                handled = true
              }
            },
          },
          onClose: () => {
            if (handled) return
            reject(new AbortError())
            handled = true
          },
        }
      )
    )
    return promise
  })
}

export function requireParent() {
  return createThunk(async dispatch => {
    const { formatMessage } = dispatch(getIntl())
    const checkIsParent = (user: StoreProfileUser) => {
      if (!user) throw new AppError('Parent account type required, got nothing').withLocalizedMessage(formatMessage(messages.is_nothing))
      if (user.account_type === 'sitter') throw new AppError('Parent account type required, got Sitter').withLocalizedMessage(formatMessage(messages.is_sitter))
      if (!user.registration_completed)
        throw new AppError('User requires additional registration').withLocalizedMessage(formatMessage(messages.is_registration))
    }

    const user = await dispatch(requireUser())
    checkIsParent(user)
  })
}

const messages = defineMessages({
  is_nothing: { id: "store.actions.requireLogin.messages.is_nothing.94d1", defaultMessage: 'Необходим тип аккаунта Родитель, а вы не авторизованы' },
  is_sitter: { id: "store.actions.requireLogin.messages.is_sitter.28db", defaultMessage: 'Необходим тип аккаунта Родитель, а вы Ситтер' },
  is_registration: { id: "store.actions.requireLogin.messages.is_registration.e7ff", defaultMessage: 'Аккаунту необходима регистрация' },
})
